export function getFilteredUsers(users, email) {
  let filteredUsers = users.filter((user) => {
    return user.createdBy === email;
  });
  return filteredUsers;
}
